// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"c1bfc6ae","455":"21c88120","977":"72fb5178"}[chunkId] + ".chunk.js";
};